import React from 'react'

import { CustomerInfo } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import styles from './requestPayment.module.scss'
import sessionResetDate from '../common/content/sessionResetDate'

const LastSessionModal = ({ firstName, lastName, company }: LastSessionModalProps) => {
  return (
    <div className={styles['modal-content']}>
      <h2 className={styles['main-header']}>Thank you!</h2>
      <div>
        <p>
          Your payment was successfully submitted. Please be aware that your client,{' '}
          <span className={styles.capitalize}>{firstName}</span> <span className={styles.capitalize}>{lastName}</span>{' '}
          has now utilized all available sessions covered under their Lyra benefit.{' '}
          {sessionResetDate({ employer: company?.label, date: company?.session_count_starts_on })} Depending on the
          sponsoring company and the client{"'"}s health plan, they may have access to additional sessions through
          Health Plan Integration. Please review{' '}
          <a
            href='https://provider-support.lyrahealth.com/hc/en-us/sections/4402710918419-Sponsoring-Company-Session-Limits-and-Policies'
            target='_blank'
            rel='noreferrer'
          >
            Sponsoring Company Session Limits and Policies
          </a>{' '}
          for more information.
        </p>
        <p className='paragraph-small'>
          For any questions, please contact <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a>
        </p>
      </div>
    </div>
  )
}

type LastSessionModalProps = {
  firstName: string
  lastName: string
  company?: CustomerInfo
}

export default LastSessionModal
